module.exports = __webpack_public_path__ + "static/media/3.a00b1ee9.jpg";